<template>
  <div>
    <div v-if="parseInt(pvtype) === 1">浏览量：{{ count }}</div>
    <div :class="[pvStyle]" v-if="parseInt(pvtype) === 2"><i class="icon"></i><span v-if="count !== 0" class="desc">{{ count }}</span></div>
  </div>
</template>

<script>
export default {
  name: 'pv',
  props: ['pvtype', 'pvStyle', 'count']
}
</script>

<style lang="scss" scoped>
.iconpv1{
  display: inline-block;
  transition: all 0.3s;
  position: relative;
  .icon{
    display: inline-block;
    width: 32px;
    height: 24px;
    background: url('../../assets/common/icon/icon-group2.png') no-repeat;
    background-position: 0px -133px;
    vertical-align: middle;
  }
  .desc{
    display: inline-block;
    height: 14px;
    line-height: 14px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/amount/pv.vue